export default __webpack_public_path__ + "static/media/Demonpiercer.1c3f3655.jpg";